import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import Form from './Form';

export default function Index({
  enterpriseId, avatarId,
}) {
  return (
    <div className="ibox-content mt20">
      <h2 className="block-title">Setup LeggUP AI Coach</h2>
      <Row>
        <Col md={8}>
          <p>
            Choose AI Coach to this Enterprise.
          </p>
        </Col>
        <Col md={4}>
          <Form enterpriseId={enterpriseId} avatarId={avatarId} />
        </Col>
      </Row>
    </div>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  avatarId: PropTypes.number,
};

Index.defaultProps = {
  avatarId: null,
};
